import { render, staticRenderFns } from "./Editors.vue?vue&type=template&id=4074916e&scoped=true"
import script from "./Editors.vue?vue&type=script&lang=ts"
export * from "./Editors.vue?vue&type=script&lang=ts"
import style0 from "./Editors.vue?vue&type=style&index=0&id=4074916e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4074916e",
  null
  
)

export default component.exports